import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { AuthEffects } from './auth.effects';
import { StoreModule } from '@ngrx/store';
import * as fromAuthState from './auth.reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromAuthState.authFeatureKey, fromAuthState.reducer),
    EffectsModule.forFeature([AuthEffects]),
  ],
})
export class AuthModule {}
